const inputTypeFiles = document.querySelectorAll('[type="file"]');

if (inputTypeFiles.length) {
    [].forEach.call(inputTypeFiles, inputTypeFile => {
        const defaultValue = inputTypeFile.parentElement.querySelector('label').innerText;

        inputTypeFile.onchange = () => {
            const fileValue = inputTypeFile.value;
            const startIndex = (fileValue.indexOf('\\') >= 0 ? fileValue.lastIndexOf('\\') : fileValue.lastIndexOf('/'));
            let filename = fileValue.substring(startIndex);

            if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
                filename = filename.substring(1);
            } else {
                filename = defaultValue;
            }

            inputTypeFile.parentElement.querySelector('label').innerText = filename;
        };
    });
}